<!-- 生活贷 -->
<template>
  <div class='life-loan relative-wrap'>
    <div class="main-content pad-side20" :style="{height: windowHeight}">
      <input name="姓名" type="text" placeholder="请输入您的姓名" v-model="reqData.idName" @blur="idNameBlur">
      <input name="身份证号" type="text" placeholder="请输入身份证号" maxlength="18" v-model="reqData.idNo">
      <input name="手机号" type="number" placeholder="请输入手机号" oninput="if(value.length>11)value=value.slice(0,11)" v-model="reqData.phoneNo">
      <div class="relative-wrap" @click="showPicker('regionPicker')">
        <input name="户籍" type="text" placeholder="请问您的【户籍地/现居地】来自以下哪个地区" disabled v-model="reqData.area">
        <img src="@/assets/imgs/icon/arrow-right.png" alt="" class="arrow">
      </div>
      <div class="protol flex align-items-center" @click.stop="agree=!agree">
        <img src="@/assets/imgs/icon/checked.png" alt="" v-show="agree">
        <img src="@/assets/imgs/icon/check.png" alt="" v-show="!agree">
        <p class="font10">请阅读并同意<span @click.stop="readProtol(12)">《报名须知》</span><span @click.stop="readProtol(9)">《隐私政策》</span></p>
      </div>
      <div class="flex justify-content-center">
        <input name="预约报名" type="button" value="预约报名" class="mid-btn" @click="saveAppointment">
      </div>
    </div>
    <AreaPicker ref="regionPicker" @onConfirm="getRegionPickerVal"/>
  </div>
</template>

<script>
import AreaPicker from "@/components/AreaPicker";
import { reqSaveLifeLoanAppoint } from '@/api';
import { checkPhone, checkIDNum, checkChinese } from '@/utils/verifyFunc'

export default {
  name: 'LifeLoan',

  components: {
    AreaPicker,
  },

  data () {
    return {
      windowHeight: '',
      agree: false,
      reqData: {
        idNo: "",
        idName: "",
        phoneNo: "",
        area: ""
      },
    };
  },
  created() {
    this.windowHeight = document.documentElement.clientHeigh + 'px'
  },
  activated() {
    let isAgree = localStorage.getItem('agreeProtol')
    // if(isAgree) {
    //   this.agree = true
    // }
  },

  methods: {
    idNameBlur() {
      if (this.reqData.idName && !checkChinese(this.reqData.idName)){
        this.$toast("请输入中文名称")
        return false
      } else {
        return true
      }
    },
    readProtol(type) {
      this.$router.push(`/protol?type=${type}`)
    },
    showPicker(type) {
      this.$refs[type].show = true
    },
    getRegionPickerVal(val) {
      this.reqData.area = val[0].name + '/' + val[1].name + '/' + val[2].name
    },
    saveAppointment() {
      let { reqData, agree } = this;

      if(!reqData.idName) {
        this.$toast("请输入您的姓名")
        return;
      }
      if (!this.idNameBlur()) {
        return;
      }
      if(!reqData.idNo) {
        this.$toast("请输入您的身份证号码")
        return;
      }
      if(!checkIDNum(reqData.idNo)) {
        this.$toast("请输入正确的身份证号码")
        return;
      }
      if(!reqData.phoneNo) {
        this.$toast("请输入您的手机号")
        return;
      }
      if(!checkPhone(reqData.phoneNo)) {
        this.$toast("请输入正确的手机号")
        return;
      }
      if(!reqData.area) {
        this.$toast("请选择地区")
        return;
      }
      if(!agree) {
        this.$toast("请阅读并同意《报名须知》《隐私政策》")
        return;
      }

      reqSaveLifeLoanAppoint(reqData).then(res => {
        this.$toast('预约成功')
        setTimeout(() => {
          this.$router.push("/")
        }, 800)
      })
    }
  },
}

</script>

<style lang='less' scoped>
  .life-loan {
    min-height: 100vh;
    height: 667px;
    background: #F1C16F url('../../assets/imgs/other/life-laon.png') top center no-repeat;
    background-size: 100% auto;
  }
  .main-content {
    position: absolute;
    top: 308px;
    left: 0;
    width: 100%;
    box-sizing: border-box;
  }
  input[type="text"], input[type="number"] {
    line-height:38px;
    background:rgba(255,255,255,1);
    border-radius:22px;
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px;
    margin-bottom: 20px;
    font-size: 12px;
  }
  input::placeholder {
    color: #BEBEBE;
  }
  .arrow {
    width: 24px;
    position: absolute;
    top: 6px;
    right: 10px;
  }
  .protol {
    font-size: 10px;
    img {
      width: 12px;
      margin-right: 5px;
    }
    span {
      color: #238DF8;
      padding: 0 2px;
    }
  }
  .mid-btn {
    width: 295px;
    line-height: 48px;
    margin-top: 33px;
  }
</style>